import { render, staticRenderFns } from "./SearchableDocumentsListProjects.vue?vue&type=template&id=d3524d52"
import script from "./SearchableDocumentsListProjects.vue?vue&type=script&lang=ts"
export * from "./SearchableDocumentsListProjects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3524d52')) {
      api.createRecord('d3524d52', component.options)
    } else {
      api.reload('d3524d52', component.options)
    }
    module.hot.accept("./SearchableDocumentsListProjects.vue?vue&type=template&id=d3524d52", function () {
      api.rerender('d3524d52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/SearchableDocumentsListProjects.vue"
export default component.exports